import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { WhatsappCloudApiService } from '../../shared/whatsapp-cloud-api.service';
import { WhatsappCloudApiWarningEnum } from '../../shared/models/whatsapp-cloud-api-warning.enum';

@Component({
  selector: 'app-step-payment-line',
  templateUrl: './step-payment-line.component.html',
  styleUrls: ['./step-payment-line.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StepPaymentLineComponent {
  @Input() migration: boolean;
  @Input() hasWarnings: boolean;

  account: string;
  WhatsappCloudApiWarningEnum = WhatsappCloudApiWarningEnum;

  constructor(
    public alcmeonContextService: AlcmeonContextService,
    public whatsappCloudApiService: WhatsappCloudApiService,
    private customRouter: CustomRouter
  ) {
    if (this.alcmeonContextService.waCloudApiSettings?.data) {
      const { phone_number } = this.alcmeonContextService.waCloudApiSettings.data;
      this.account = phone_number;
    }
  }

  goToAccount() {
    const { site_id } = this.alcmeonContextService.waCloudApiSettings.data;
    this.customRouter.go('auth.alcmeon.fuse.account-edit', { id: site_id });
  }
}
